import m1_examRegMenu from "@components/excuseMenu/m1_examRegMenu";
import m2_examRegMenu from "@components/excuseMenu/m2_examRegMenu";
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default{
    components: {
        "m2Sidebar":m2Sidebar,
        "m1ExamRegMenu": m1_examRegMenu,
        "m2ExamRegMenu": m2_examRegMenu
    },
    data(){
        return {
            batchNum: '',
            state: 0,
            nodeInfo: {},
            buttonDisplay: false,
            buttonShow: '',
            buttonState: true,
        }
    },
    methods: {
        getData: function () {
            this.$http.get(globalProvider.serviceUrl('ex_exm/g/elc')).then((data) => {
                if (data.body.code == resultCode.Success) {
                    this.$store.commit('setPromiseState', data.body.data.status);
                    if (!data.body.data.status) {
                        this.nextStep()
                    }
                    this.state = data.body.data.status;
                    this.nodeInfo = data.body.data;
                    if (this.nodeInfo.read_time > 0) {
                        let time = this.nodeInfo.read_time;
                        for (let i = 1; i <= this.nodeInfo.read_time; i++) {
                            window.setTimeout(() => {
                                --time;
                                this.buttonShow = "我同意（" + time + "）";
                                this.buttonDisplay = true;
                                if (time == 0) {
                                    this.buttonShow = '我同意';
                                    this.buttonState = false;
                                }
                            }, i * 1000)
                        }
                    }
                    else {
                        this.buttonDisplay = true;
                        this.buttonShow = '我同意';
                        this.buttonState = false;
                    }
                }
                else if (data.body.code == resultCode.NotSuccess) {
                    this.$alert(getErrorMessage(data.body.message), '提示', {
                        confirmButtonText: '确定'
                    });
                }
            });
        },
        nextStep: function () {
            let RegInfoModel = this.$store.state.examRegInfo.examRegInfo;
            if (RegInfoModel.text_info_confs.length > 0) {
                this.$router.push({name: 'excuseExam.baseCollection'});
            }
            else if (RegInfoModel.pic_info_confs.length > 0) {
                this.$router.push({name: 'excuseExam.imgCollection'});
            }
            else if (RegInfoModel.file_info_confs.length > 0) {
                this.$router.push({name: 'excuseExam.fileCollection'});
            }
            else {
                this.$router.push({name: 'excuseExam.chooseExamRegion'});
            }
        },
        frontStep: function () {
            this.$router.push({name: 'excuseExam.chooseBatch'});
        }
    },
    created: function () {
        this.getData();
        this.batchNum = this.$store.state.examInfo.batch;
        this.$store.commit('setHeaderState', '6');
    }
}